import ProductSNListTable from "./productSNListTable.container";

export default ProductSNListTable;
